import type { EventName } from '../../shared/protocol';
import { storage } from './storage';
import { validMetricsId } from '../../shared/telemetry';
import { QA_ROOM_ID } from '../../shared/rooms';

export function telemetryDisabled(href: string) {
  const query = new URL(href).searchParams;
  return query.get('telemetry') === 'off' || query.get('room') === QA_ROOM_ID;
}

let ephemeralId: string | undefined;
function metricsId() {
  const saved = storage.get('metricsId.v1');
  if (validMetricsId(saved)) return saved;
  const id = ephemeralId ??= crypto.randomUUID();
  storage.set('metricsId.v1', id);
  return id;
}
export function resetTelemetryIdentity() { ephemeralId = undefined; storage.remove('metricsId.v1'); }

export function record(event: EventName) {
  if (telemetryDisabled(window.location.href)) return;
  void fetch('/api/events', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ event, clientId: metricsId(), eventId: crypto.randomUUID() }), keepalive: true }).catch(() => {});
}
export function recordVisit() {
  if (telemetryDisabled(window.location.href)) return;
  record('room_enter');
  const day = new Date().toISOString().slice(0, 10);
  const previous = storage.get('lastVisitDay');
  if (previous && previous < day) record('return_day');
  storage.set('lastVisitDay', day);
}
